import { ConnectionService } from "./connection.service";

// #region Constants

const DEFAULT_SKIP       = 0;
const DEFAULT_SORT_KEY   = 'Name';
const DEFAULT_SORT_ORDER = 'Asc';
const FAILURE_RESULT     = 'Failure';

// #endregion Constants

export const fileBrowserConnection = ConnectionService.getAutoReconnectConnection(
  "/file-browser"
);

async function connectIfNeeded() {
  if (fileBrowserConnection.state === "Disconnected") {
    await fileBrowserConnection.start();
  }
}

export async function getFilteredContents(
  path,
  searchPattern = null,
  skip = 0,
  take = 500,
  sortKey = "Name",
  sortOrder = "Asc"
) {
  await connectIfNeeded();
  return await fileBrowserConnection.invoke(
    "GetFilteredContents",
    path,
    searchPattern,
    skip,
    take,
    sortKey,
    sortOrder
  );
}

export async function getLocationStatus(path) {
  await connectIfNeeded();
  return await fileBrowserConnection.invoke(
    "GetLocationStatus",
    path
  );
}

export async function getDrives() {
  await connectIfNeeded();
  return await fileBrowserConnection.invoke("GetDrives");
}

/**
 * Check to see if a particular path is a folder or not. Note that if the path
 * is not a folder, that does not mean it is a valid path to a file.
 * 
 * @param path The path to check.
 * @returns True if the specified path is a folder, false otherwise.
 */
export async function isFolder(path) {
  await connectIfNeeded();
  const results = await fileBrowserConnection.invoke(
    'GetFilteredContents',
    path,
    undefined,
    DEFAULT_SKIP,
    1,
    DEFAULT_SORT_KEY,
    DEFAULT_SORT_ORDER
  );

  return results.resultKind !== FAILURE_RESULT;
}
